<ng-container *ngIf="shouldShowNewEntityHub$ | async; else oldCollection">

  <ng-container *ngIf="!(isLayoutError$ | async); else error">
    <flo-entity-hub-layout
      [selectedItem]="selectedItem$ | async"
      [layout]="layout$ | async"
      [geoBlockedIds]="[]"
      [selectedTab]="selectedTab$ | async"
      [partial]="partial$ | async"
      [isLoading]="isLoading$ | async"
      [isPartialError]="isPartialError$ | async"
      [hideRightRail]="hideRightRail$ | async"
      [message]="message$ | async"
      [adConfigMap]="adConfigs$ | async"
      (lazyLoadedAdRef)="adLoadedOnChildView($event)"
      (tabClicked)="handleTabClicked($event)"
      (toggleClicked)="handleToggleClicked($event)"
      (nextPage)="handleNextPage($event)"
      (layoutHeaderCtaButton)="handleHeaderCta1ButtonClick($event)"
    >
    </flo-entity-hub-layout>
  </ng-container>
</ng-container>
<ng-template #error>
  <div class="container bg-white min-vh-100 py-5">
    <flo-error></flo-error>
  </div>
</ng-template>
<ng-template #oldCollection>
  <flo-collection-view></flo-collection-view>
</ng-template>
